import { OrgSettings } from 'features/organization/orgSettings/OrgSettings';
import { PaymentsConfig, TPaymentsConfig } from './transferPaymentsConfig';

export class AbstractPaymentProvidersEvaluatorStrategy {
  protected paymentProvidersConfig: PaymentsConfig;
  protected platformIntegrations: Record<string, any>;
  protected organizationSettings: OrgSettings;

  constructor(
    paymentProvidersConfig: PaymentsConfig,
    platformIntegrations: Record<string, any>,
    organizationSettings: OrgSettings
  ) {
    this.paymentProvidersConfig = paymentProvidersConfig;
    this.platformIntegrations = platformIntegrations;
    this.organizationSettings = organizationSettings;
  }

  /**
   * @param {object} paymentProvider
   * @public
   * @returns {'eligible' | 'requiresCustomerServiceOnboarding'}
   */
  getProviderEligibilityStateForPayout(paymentProvider: any) {
    if (
      this.platformIntegrations.isPaymentProviderRequiresCSOnboarding(
        paymentProvider
      )
    ) {
      return 'requiresCustomerServiceOnboarding';
    }

    return 'eligible';
  }

  isBatchPayout() {
    throw new Error('Not implemented');
  }

  getPayouts() {
    throw new Error('Not implemented');
  }

  isProviderEligibleForPayout() {
    throw new Error('Not implemented');
  }

  getAllPossiblePaymentProviders() {
    throw new Error('Not implemented');
  }
}
